import pb from "../../lib/pb";

const ProductShippingService = {

    async getByProduct(productId) {

        if (!productId) {
            return null;
        }

        try {

            return await pb
                .collection("product_shipping")
                .getFirstListItem(
                    `product="${productId}"`
                );

        }

        catch (error) {

            if (error?.status === 404) {
                return null;
            }

            throw error;

        }

    },

    async create(data) {

        return await pb
            .collection("product_shipping")
            .create(data);

    },

    async update(id, data) {

        return await pb
            .collection("product_shipping")
            .update(
                id,
                data
            );

    },

    async saveForProduct(
        productId,
        brandId,
        ownerId,
        data
    ) {

        const existing =
            await this.getByProduct(productId);

        const payload = {

            product: productId,

            brand: brandId,

            owner: ownerId,

            ...data

        };

        if (existing) {

            return await this.update(
                existing.id,
                payload
            );

        }

        return await this.create(
            payload
        );

    },

    async remove(id) {

        return await pb
            .collection("product_shipping")
            .delete(id);

    },

    /*
    --------------------------------------------------
    Realtime Subscription
    --------------------------------------------------
    */

    subscribe(productId, callback) {

        if (!productId || !callback) {
            return null;
        }

        return pb
            .collection("product_shipping")
            .subscribe(
                "*",
                event => {

                    if (
                        event?.record?.product === productId
                    ) {

                        callback(event);

                    }

                }
            );

    },

    /*
    --------------------------------------------------
    Realtime Unsubscribe
    --------------------------------------------------
    */

    async unsubscribe() {

        await pb
            .collection("product_shipping")
            .unsubscribe();

    }

};

export default ProductShippingService;